
import SceneNodeDialog from './SceneNodeDialog.vue';
import _get from 'lodash/get';
import _set from 'lodash/set';

export default {
  components: {
    SceneNodeDialog: SceneNodeDialog
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      selectNode: null
    };
  },
  mounted: function mounted() {
    this.selectNode = _get(this.model, this.config.prop);
  },

  methods: {
    realProp: function realProp() {
      var index = this.config.prop.lastIndexOf('.');
      if (index === -1) {
        return this.config.prop;
      }
      return this.config.prop.slice(0, index);
    },
    openSceneNodeDialog: function openSceneNodeDialog() {
      this.$refs.SceneNodeDialog.openDialog();
    },
    selectNodeHandler: function selectNodeHandler(node) {
      var prop = this.realProp();
      _set(this.model.script, prop, node);
      _set(this.model, this.config.prop, node.name || null);
      if (node) {
        this.selectNode = node.name;
      }
    }
  }
};